import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import TransitionBase, { UNMOUNTED, ENTERING, ENTERED, EXITING, EXITED, } from 'react-transition-group/Transition';
/**
 * react-transition-groupのラッパーコンポーネント
 * @param props
 * @constructor
 */
export const Transition = (props) => {
    const { children, isShow, mountOnEnter = true, reDrawTimings = ['onEnter', 'onExit'], timeout = 500, unmountOnExit = true, } = props;
    /**
     * chrome対応: transition on/offで強制的に再計算を走らせる
     */
    const reDraw = (node) => {
        // eslint-disable-next-line no-unused-expressions
        node.offsetHeight;
    };
    return (_jsx(TransitionBase, Object.assign({ in: isShow, mountOnEnter: mountOnEnter, onEnter: reDrawTimings.includes('onEnter') ? reDraw : undefined, onExit: reDrawTimings.includes('onExit') ? reDraw : undefined, timeout: timeout, unmountOnExit: unmountOnExit }, { children: children })));
};
export const TRANSITION_STATUS_UNMOUNTED = UNMOUNTED;
export const TRANSITION_STATUS_ENTERING = ENTERING;
export const TRANSITION_STATUS_ENTERED = ENTERED;
export const TRANSITION_STATUS_EXITING = EXITING;
export const TRANSITION_STATUS_EXITED = EXITED;
